import React from 'react';
import styled from 'styled-components';
import { Dialog, Item } from '@zebra-fed/zds-react-desktop';
import { Icon } from "@zebra-fed/zds-react-desktop";
import '@zebra-fed/icons/Alert/index.css'
import {useTranslation} from "react-i18next";

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px;
    text-align: center;
`

export default function InfoModal(props) {
    const dialogRef = props.modalRef;
    const { t } = useTranslation();
    return (
        <>
            <Dialog ref={dialogRef}
                key='dialog2'
                width='520px'            
                items={[
                    <Item type='button' style={{backgroundColor: '#', width: '102px'}} onClick={() => dialogRef.current.toggleDialog()}>{t('ok')}</Item>,
                ]}
                headerStyle={{display: 'none' }}
                bodyStyle={{padding: '0px', width: '100%'}}
                footerStyle={{padding: '24px'}}
                cardStyle={{ marginBottom: '60px'}}
            >
                <ModalHeader>
                    {t('error')}
                </ModalHeader>
                <MainContent>
                    <Icon 
                        category={'alert'}
                        name={'warning'}
                        color={'#ED1C24'}
                        style={{ paddingBottom: '12px'}}
                        size={80}
                    />
                    {props.msg}
                </MainContent>
            </Dialog>
        </>
    )
}